import { Link } from "react-router-dom";
import type { ReactNode } from "react";
import { Lock, RefreshCw } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useMyCbt } from "@/hooks/usePreparation";
import { useHasCbt } from "@/lib/entitlements";

type Props = {
  children: ReactNode;
};

export function CbtSubscriptionGate({ children }: Props) {
  const { data: cbt, isLoading } = useMyCbt();
  const hasAccess = useHasCbt();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <p className="text-sm text-muted-foreground">Checking subscription…</p>
      </div>
    );
  }

  if (!cbt && !hasAccess) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background p-4">
        <Card className="w-full max-w-md">
          <CardContent className="p-6 text-center space-y-4">
            <div className="mx-auto h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center">
              <Lock className="h-5 w-5 text-primary" />
            </div>
            <div>
              <h1 className="text-xl font-semibold">CBT & Mock Subscription required</h1>
              <p className="text-sm text-muted-foreground mt-1">
                Renew your subscription to unlock Structured CBT, Random Practice and Mock Exams.
              </p>
            </div>
            <Button asChild>
              <Link to="/cbt-practice"><RefreshCw className="h-4 w-4 mr-2" />Renew Subscription</Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return <>{children}</>;
}